import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "./telemetry";

/** A screen that throws while rendering is reported, and the person gets a way back instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError("render", Object.assign(new Error(error.message), { name: error.name, stack: `${error.stack ?? ""}\n${info.componentStack ?? ""}` }));
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ padding: 24, font: "16px -apple-system,system-ui,sans-serif" }}>
        <b>Something went wrong.</b>
        <p>It has been reported. Reloading usually fixes it.</p>
        <button onClick={() => location.reload()}>Reload</button>
      </div>
    );
  }
}
